







import { getFederationComponent } from '@src/federations/getFederationComponent';
import {
    isSocialAppEnabled,
    isSocialEnabled,
} from '@socialFederation/helpers';
import { getShellConfig } from '@src/config/shell/config';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    name: 'EventDetailsPageHeader',
    setup() {
        return {
            isSocialEnabled: isSocialEnabled(),
            isSocialAppEnabled: isSocialAppEnabled(),
            useSimplifiedTournamentName: getShellConfig().remoteConfig.sportsOffer.useSimplifiedTournamentName,
        };
    },
    components: { EventDetailsScoreboardAndSubnav: getFederationComponent(() => import('stats/EventDetailsScoreboardAndSubnav')) },
});
